import {Component, input} from '@angular/core';
import {Text} from '../text/text';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'app-number',
  imports: [
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './number.html',
  styleUrl: './number.css',
})
export class Number extends Text {
  step = input<number>();
  min = input<number>();
  max = input<number>();

  override inputmode = input<string>('numeric');
}
